// src/authProvider.js
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';

// Change this to be your own login check route.
const login_uri = process.env.REACT_APP_API_ENTRYPOINT + '/login_check';

export default (type, params) => {
  switch (type) {
    case AUTH_LOGIN:
      const { username, password } = params;
      const request = new Request(`${login_uri}`, {
        method: 'POST',
        body: JSON.stringify({ username, password }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });

      return fetch(request)
        .then(response => {
          if (response.status < 200 || response.status >= 300) throw new Error(response.statusText);

          return response.json();
        })
        .then(({ token, data }) => {
          localStorage.setItem('ltk-comments-admin-token', token); // The JWT token is stored in the browser's local storage
          localStorage.setItem('ltk-comments-admin-id', data.user_id);
          window.location.replace('/');
        });

    case AUTH_LOGOUT:
      localStorage.removeItem('ltk-comments-admin-token');
      localStorage.removeItem('ltk-comments-admin-id');
      break;

    case AUTH_ERROR:
      if (401 === params.status || 403 === params.status) {
        localStorage.removeItem('ltk-comments-admin-token');
        localStorage.removeItem('ltk-comments-admin-id');

        return Promise.reject();
      }
      break;

    case AUTH_CHECK:
      return localStorage.getItem('ltk-comments-admin-token') ? Promise.resolve() : Promise.reject();

    default:
      return Promise.resolve();
  }
}
